// extracted by mini-css-extract-plugin
export default {"header":"accountCredentials_header__zw+2M","list":"accountCredentials_list__Zdw3s"};